import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type Field from 'modules/custom_resources/store/models/customResources/Field'

const canEditField = (canManage: boolean, field: Field | CustomField | null | undefined) => {
  if (!field) return true

  if (field.isReadonly) return false

  return canManage
}

export default canEditField
